import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { resendEmailApi } from "../emailApi"
import { enqueueSnackbar } from "notistack"

export const useResendEmail = () => {
    const { mutate } = useApiMutation(resendEmailApi, {
        async onSuccess(_, data) {
            if (data?.serviceResponse?.displayMessage) {
                enqueueSnackbar({
                    variant: "success",
                    message: data?.serviceResponse?.displayMessage,
                })
            }
        },
    })

    return { mutate }
}
